<div *ngIf="isShown" class="sidebar-overlay">
</div>
<div *ngIf="isShown" class="sidebar-container py-4 pr-2 pl-6 overflow-hidden p-0 issueListingStyle_1">
  <div class="dark-gray-section d-flex justify-content-between align-items-center pt-6 pb-5 px-4 cp-border-bottom">
    <h4>Generate Market Listing Documents</h4>
    <div>
      <button class="cp-failure-btn back-button issueListingStyle_2" id="market-listing-modal-close"
        (click)="closeSidePanel()">X</button>
    </div>
  </div>
  <overlay-scrollbars class="scroll-container issueListingStyle_3">
    <div>
      <div class="mt-4 mb-3 ml-5 mr-2 pb-3">
        Select <em>Listing Date</em> and <em>Stock Exchange</em> to generate Market Listing docs.
      </div>
      <div class="dark-section mb-4 mx-5 pt-1 px-3">
        <form autocomplete="off" class="form-section px-3 py-5" [formGroup]="listingForm">
          <div class="row">
            <div class="col-md-5">
              <div class="compt-input">
                <label>Listing Date</label>
                <div class="r-value-box">
                  <input [attr.value]="listingForm.get('listing_date').value" id="listing-value-date"
                    class="form-control attachement" [outsideDays]="'collapsed'" placeholder="dd/mm/yyyy"
                    name="value-date" [markDisabled]="isWeekendAndHolidayDisabled" formControlName="listing_date"
                    ngbDatepicker #valueDate="ngbDatepicker" (click)="valueDate.toggle()">
                  <div class="input-group-append icons-calender">
                    <button class="btn" (click)="valueDate.toggle()" type="button" id="listing-value-date">
                      <i class="far-i fa fa-calendar"></i>
                    </button>
                  </div>
                </div>
                <div class="error-text"
                  *ngIf="!listingForm.get('listing_date').pristine && listingForm.get('listing_date').errors">
                  <small [hidden]="!listingForm.get('listing_date').errors">
                    Listing Date is required.
                  </small>
                </div>
              </div>
            </div>
            <div class="col-md-7">
              <div class="compt-input">
                <label for="stock-exchange">Stock Exchange(s)</label>
                <ng-select [attr.value]="listingForm.get('stock_exchange').value" id="listing-stock-exchange" 
                  name="stock-exchange" [items]="stockExchangeList" bindLabel="name" bindValue="id" class="icici-custom"
                  [hideSelected]="true" [loading]="false" formControlName="stock_exchange">
                </ng-select>
                <span>

                </span>
                <div class="error-text"
                  *ngIf="!listingForm.get('stock_exchange').pristine && listingForm.get('stock_exchange').errors">
                  <small [hidden]="!listingForm.get('stock_exchange').errors">
                    Stock Exchange is required.
                  </small>
                </div>
              </div>
            </div>
          </div>
          <h6 *ngIf="listingId && listedIssues && listedIssues.length === 0" class="pt-1 pb-4 mt-1 mb-3 info-text font-italic">
            There are no issues with value date on the selected listing date.
          </h6>
          <h6 *ngIf="listingId && listedIssues && listedIssues.length !== 0 && documents && documents.length === 0" class="pt-1 pb-4 mt-1 mb-3 info-text font-italic">
            No listing documents were created for this date.
          </h6>
          <div class="mt-4 ml-4 pt-3 pb-3 row">
            <div class="text-right offset-6 col-6">
              <button *ngIf="!allDocsSigned" id="get-listing-documents" [attr.disabled]="listingForm.invalid ? true : null"
                class="btn  btn-success text-left for-icon-right for-right-arrow" (click)="getListingDocuments()">
                Get Documents
              </button>
            </div>
          </div>
        </form>
      </div>

      <h4 class="ml-5 mr-2" *ngIf="listedIssues && documents && listedIssues.length && documents.length">
        Documents
      </h4>
      <div *ngIf="listedIssues && documents && listedIssues.length && documents.length" class="dark-section mt-5 mx-5 pt-3 pb-5 px-5">
        <div>
          <span class="warning-text" *ngIf="allDocsUnsigned">Status: {{listingOverallStatus.UNSIGNED}}</span>
          <span class="warning-text" *ngIf="allDocsSentForSign && !allDocsSigned">Status:
            {{listingOverallStatus.SENT_FOR_SIGN}}</span>
          <span class="success-text" *ngIf="allDocsSigned">Status: {{listingOverallStatus.SIGNED}}</span>
        </div>
        <div class="row">
          <div class="col-md-6 mt-6" *ngFor="let document of documents">
            <button id="generate-doc-{{documentNames[document.name]}}"
              class="btn btn-block btn-outline-normal text-left thick {{document.classes}}"
              (click)="handleDocumentAction(document)">
              {{documentNames[document.name]}}
              <span *ngFor="let iClass of document.iconClasses">
                <i class="{{iClass}} {{document.iconClass}}"></i>
              </span>
            </button>
            <small class="orange-color" *ngIf="document.additionalText">
              {{document.additionalText}}
            </small>
          </div>
        </div>

      </div>
      <div *ngIf="listedIssues && documents && listedIssues.length && documents.length && !allDocsSentForSign" class="mt-3 mx-5 pt-3 pb-3 px-3">
        <div class="row">
          <div class="text-right offset-6 col-6">
            <button id="sign-listing-documents" class="btn  btn-success text-left for-icon-right for-right-arrow"
              (click)="showSignatoryModal()">
              Sign Documents
            </button>
          </div>
        </div>
      </div>
    </div>
  </overlay-scrollbars>
</div>